const isDev = process.env.NODE_ENV !== 'production';
const DEV_map = 'https://www.qishimai.cn/70applet'
const map = 'https://www.qishimai.cn/70applet'
const mapBaseURL = isDev ? DEV_map : map;

export const api = {
  getAppId: '/WX/getJsParams', // 获取appId

  groupSelect: '/teamScheme/public/findSchemeByTeamId', // 查询团期行程
  travelSelect: '/scheme/findSchemeAndRouteByUUId', // 查询行程报价
  templateSelect: '/sys_scheme_model/selectSchemeIdBackRoute', // 查询行程报价模板
  confirmTravel: '/scheme/confirmScheme', // 确认行程
  addOpinion: '/scheme/addAlterOpinion', // 提交修改意见

  hotelSelect: '/hotel/findHotelById', // 查询酒店
  spotSelect: '/Sys_scenic/selectByScenicId', // 查询景点
  restaurantSelect: '/restaurant/findRestaurantById', // 查询餐厅
  activitySelect: '/sys_action/findActionById', // 查询活动
  placeSelect: '/place/findById',
  shopSelect: '/sys_shop/findById',
  findByPoiDetails: '/sys_routebook/public/findByPoiDetails', // get ?id=44 素材主要信息，在地图上使用
  findByBookCities: '/sys_routebook/public/findBookCitiesById', // get ?id=44 城市主要信息，在地图上使用

  getDirections: `${mapBaseURL}/map/getDirections`, // get 可选线路 ?origin=-37.81223%2C144.96254&waypoints=31.0962335,121.1822241%2C31.1847781,121.3796085&destination=-34.92788%2C138.60008&mode=transit

  getItinerary: '/sys_routebook/public/findItineraryList', // 查询路书行程单信息
  getPriceItinerary: '/scheme/public/findItineraryList', // 查询报价行程单信息
  getTripItinerary: `/sys_free_scheme/public/findItinerary`, // 查询报价行程单信息 新
  getTripByUuid: `/sys_free_scheme/public/findByUuid`, // 查询行程报价 新
  getTripTemplateByUuid: `/sys_free_scheme_model/public/findByUuid`, // 查询行程报价模板 新
  tripAddAlter:`/sys_free_scheme/public/addAlterOpinion`, // 行程意见
  tripConfirmScheme:`/sys_free_scheme/public/confirmScheme`,

  evaluateAdd: '/h5/v1/insertTeamServiceOption', // 国内跟团服务评价

  getAuthCode: '/applet/common/getAuthCode', // 获取验证码
  insertClue: '/bookApplet/v1/insertClue' // 添加定制
};

export const mapboxAccessToken = 'pk.eyJ1Ijoic2FiZXJ5dXkiLCJhIjoiY2szaDQzeHF0MDgycDNtcXBzbjMxZnd4bCJ9.xymH2t5xjWL2noK6HhofcQ';
export const mapboxUrl = 'https://api.mapbox.com';
export const mapboxApi = {
  directions: `${mapboxUrl}/directions/v5`,
}
export const mapboxProfile = {
  drivingTraffic: 'mapbox/driving-traffic',
  driving: 'mapbox/driving',
  walking: 'mapbox/walking',
  cycling: 'mapbox/cycling',
}



// WEBPACK FOOTER //
// ./src/utils/constVar.js